angular.module('elfium').controller('dashboardActivityListController', ['$scope', 'taskService', 'elfiumToastrService',
    function ($scope, taskService, elfiumToastrService) {
        var that = this;
        that.init = function () {
        	that.getTasks();
        };
        that.getTasks = function () {
        	var today = new Date();
	        var day = today.getDay();
	        var diffToLastSunday = today.getDate() - day + (day === 0 ? -7 : 0)
	        var lastSunday = new Date(today.setDate(diffToLastSunday));
			var thisSunday = new Date(today.setDate(diffToLastSunday + 7));
            taskService.getTasksBetweenDates(lastSunday, thisSunday).then(function (tasks) {
                $scope.tasks = tasks;
            }, elfiumToastrService.error);
        };
        that.init();
    }
]); 


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardActivityListController.ts